/* istanbul ignore file */

export const getDefaultOptions = () => ({
  autoDetectHighContrast: true,
  scrollBeyondLastLine: false,
  fontSize: 16,
});
